import type { UnionTypeLibelle } from '../../../techniques'

export const TypeQualification = ['Rncp', 'Cqp', 'Clea'] as const

export type TypeQualification = (typeof TypeQualification)[number]

export const TypeQualificationLibelle: UnionTypeLibelle<TypeQualification> = {
  Rncp: '1 - Diplôme ou titre enregistré au RNCP',
  Cqp: '2 - Certificat de qualification professionnelle (CQP)',
  Clea: '3 - Certification relative au socle de connaissance / compétences professionnelles (CléA)',
} as const
